<template>
  <article class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title -no-space">{{ wp.executive.title }}</h2>
      <p v-if="wp.executive.text">
        {{ wp.executive.text }}
      </p>
    </div>

    <section class="card-article">
      <article v-for="entry in wp.executive.members" :key="entry.name" class="card-article__item">
        <section class="card-article__content">
          <div class="card-article__hgroup">
            <h2 class="card-article__uptitle -accent">{{ entry.position }}</h2>
            <h3 class="card-article__title">{{ entry.name }}</h3>
          </div>

          <p>{{ entry.text }}</p>
        </section>
      </article>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutCommitteesIndex',
  inject: ['wp']
}
</script>
